<div
  #langSelectDOM
  id="bell-cont"
  [ngClass]="{ 'contrast-color': contrastColor }">
  <button mat-icon-button (click)="toggleNotificationPanel()">
    <img
      *ngIf="!newNotifications()"
      ngSrc="ui/bell.png"
      height="100"
      width="116"
      priority
      alt="Globodog notification bell" />
    <img
      *ngIf="newNotifications()"
      ngSrc="ui/bell_full.png"
      height="100"
      width="116"
      priority
      alt="Globodog notification bell full" />
  </button>

  <div id="dropdown" [ngStyle]="{ display: showMenu ? 'block' : 'none' }">
    @if (notificationList().length === 0) {
      <p class="no-notifications-container">
        {{ 'Nincsenek új értesítéseid!' | translate }}
      </p>
    } @else {
      <p id="remove-all-container">
        <button
          id="remove-all-button"
          mat-button
          color="primary"
          (click)="deleteAllNotifications()">
          {{ 'Összes értesítés törlése' | translate }}
        </button>
      </p>
      @for (n of notificationList(); track $index) {
        <div matRipple [matRippleTrigger]="trigger">
          <div class="notification-item">
            <img
              class="notification-icon"
              [ngSrc]="getIconSrc(n.messageObj!.title_loc_key!)"
              width="25"
              height="25"
              alt="event notification icon" />

            <div class="notification-text-container" #trigger>
              @switch (n.messageObj!.title_loc_key) {
                @case (NotificationType.PROGRAM_RECOMMEND) {
                  <a
                    [routerLink]="
                      currentLang() +
                      '/programs/' +
                      n.messageObj!.data!['program_id']
                    ">
                    <h3>{{ 'Új program' | translate }}</h3>
                    <div class="message-body-container">
                      {{ n.messageObj!.body }}
                    </div>
                  </a>
                }
                @case (NotificationType.PROGRAM_UPDATED) {
                  <a
                    [routerLink]="
                      currentLang() +
                      '/programs/' +
                      n.messageObj!.data!['program_id']
                    ">
                    <h3>{{ 'Program frissítve lett' | translate }}</h3>
                    <div class="message-body-container">
                      {{ n.messageObj!.body }}
                    </div>
                  </a>
                }
                @case (NotificationType.PROGRAM_DELETED) {
                  <h3>{{ 'Program törlődött' | translate }}</h3>
                  <div class="message-body-container">
                    {{ n.messageObj!.body }}
                  </div>
                }
                @case (NotificationType.PROGRAM_INTERESTED) {
                  <a
                    [routerLink]="
                      currentLang() +
                      '/programs/' +
                      n.messageObj!.data!['program_id']
                    ">
                    <h3>{{ 'Új érdeklődő' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        '{userName} érdeklődik a(z) {programName} iránt!'
                          | translate
                            : getProgramInterestedTranslateParams(
                                n.messageObj!.title_loc_args!
                              )
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.PROGRAM_JOINED) {
                  <a
                    [routerLink]="
                      currentLang() +
                      '/programs/' +
                      n.messageObj!.data!['program_id']
                    ">
                    <h3>
                      {{ 'Új résztvevő' | translate }}
                    </h3>
                    <div class="message-body-container">
                      {{
                        '{userName} részt vesz a(z) {programName} progamodban!'
                          | translate
                            : getProgramInterestedTranslateParams(
                                n.messageObj!.title_loc_args!
                              )
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.BLOG_NEW) {
                  <a [routerLink]="currentLang() + '/blog'">
                    <h3>{{ 'Új GloboDog Blogbejegyzés' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        'Új GloboDog Blogbejegyzést hoztak létre!' | translate
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.AD_MESSAGE) {
                  <h3>{{ 'GloboMarket üzeneted érkezett' | translate }}</h3>
                  <div class="message-body-container">
                    {{ 'Ellenőrízd az e-mailjeid!' | translate }}
                  </div>
                }
                @case (NotificationType.KENNEL_REQUEST) {
                  <a [routerLink]="currentLang() + '/profile-dogs/'">
                    <h3>{{ 'Falka felkérés' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        '{userName} kéri, hogy {dogName} csatlakozzon a falkájához!'
                          | translate
                            : getKennelRequestTranslateParams(
                                n.messageObj!.title_loc_args!
                              )
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.KENNEL_JOINED) {
                  <a [routerLink]="currentLang() + '/profile-dogs/'">
                    <h3>{{ 'Falkatag csatlakozott' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        '{dogName} csatlakozott a falkádhoz!'
                          | translate
                            : getKennelJoinedTranslateParams(
                                n.messageObj!.title_loc_args!
                              )
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.PROGRAM_REVIEWED) {
                  <a
                    (click)="goToProgram(n.messageObj!.data!['program_id'], n.messageObj!.data!['login_id'])">
                    <h3>{{ 'Új értékelés' | translate }}</h3>
                    <div class="message-body-container">
                      {{ 'Programodra értékelés érkezett!' | translate }}
                    </div>
                  </a>
                }
                @case (NotificationType.SERVICE_REVIEWED) {
                  <a
                    (click)="goToProvider(n.messageObj!.data!['service_id'], n.messageObj!.data!['owner_id'])">
                    <h3>{{ 'Új értékelés' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        'Szolgáltatásodra új értékelés érkezett!' | translate
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.PROGRAM_REVIEW_REPLIED) {
                  <a
                    (click)="goToProgram(n.messageObj!.data!['program_id'])">
                    <h3>{{ 'Új válasz' | translate }}</h3>
                    <div class="message-body-container">
                      {{ 'Értékelésedre válasz érkezett!' | translate }}
                    </div>
                  </a>
                }
                @case (NotificationType.SERVICE_REVIEW_REPLIED) {
                  <a
                    (click)="goToProvider(n.messageObj!.data!['service_id'])">
                    <h3>{{ 'Új válasz' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        'Értékelésedre válasz érkezett!' | translate
                      }}
                    </div>
                  </a>
                }
                @case (NotificationType.COMMENT_POSTED) {
                  <a
                    (click)="goToComment(n.messageObj!.data!['comment_id'])">
                    <h3>{{ 'Új hozzászólás' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        'Ehhez a tartalmadhoz új hozzászólás érkezett' | translate
                      }}:
                      {{ n.messageObj?.['title_loc_args']?.[0] }} 
                    </div>
                  </a>
                }
                @case (NotificationType.COMMENT_REPLY) {
                  <a
                    (click)="goToComment(n.messageObj!.data!['reply_to_id'])">
                    <h3>{{ 'Új válasz' | translate }}</h3>
                    <div class="message-body-container">
                      {{
                        'Ehhez a tartalomhoz írt kommentedre válasz érkezett' | translate
                      }}:
                      {{ n.messageObj?.['title_loc_args']?.[0] }} 
                    </div>
                  </a>
                }
              }
            </div>

            <button
              mat-icon-button
              color="primary"
              (click)="deleteNotification(n.id)">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div
            class="notification-date"
            [title]="n.created_on | date: 'yyyy.MM.dd HH:mm'">
            {{ n.created_on | date: 'yyyy.MM.dd' }}
          </div>
        </div>

        <mat-divider
          *ngIf="
            notificationList().length > 0 &&
            notificationList().length !== $index + 1
          "></mat-divider>
      }
    }
  </div>
</div>
